import React, { Component } from 'react';
import { connect } from 'react-redux';

import { getDates } from '../../util/axiosHelper';
import { fetchAgentReport, removeAgent, setTargetAgent, unsetTargetAgent } from '../../store/actions/agentActions';
import {
  clearSwitchType,
  fetchSwitchType,
  initializeUser,
  removeAccount,
  removeAccountReport,
  setTargetAccount,
} from '../../store/actions/accountActions';

import AccountHistory from './AccountHistory';
import { AccountResults } from './AccountResults';
import CSRAgentReports from './CSRAgentReports';
import { CSRAgentsResults } from './CSRAgentsResults';
import UserList from './UserList';

export class ListManager extends Component {
  constructor(props) {
    super(props);

    this.setChosenAgent = this.setChosenAgent.bind(this);
    this.removeAgentProp = this.removeAgentProp.bind(this);
    this.setChosenAccount = this.setChosenAccount.bind(this);
    this.removeChosenAgent = this.removeChosenAgent.bind(this);
    this.removeAccountProp = this.removeAccountProp.bind(this);
    this.removeAccountReportProp = this.removeAccountReportProp.bind(this);
  }

  componentDidUpdate(prevProps) {
    const { chosenAccount } = this.props;

    // Clear previous switch type when account changes
    if (prevProps.chosenAccount !== chosenAccount) {
      this.props.clearSwitchType();
    }

    // Check if chosenAccount changed from empty/undefined to having data
    const hadNoAccount = !prevProps.chosenAccount || Object.keys(prevProps.chosenAccount).length === 0;
    const hasAccountNow = chosenAccount && Object.keys(chosenAccount).length > 0;

    if (
      hadNoAccount &&
      hasAccountNow &&
      chosenAccount.footprint &&
      chosenAccount.footprint.toLowerCase().includes('chtr')
    ) {
      this.props.fetchSwitchType(chosenAccount.accountNumber, chosenAccount.divisionBillingId);
    }
  }

  removeChosenAgent() {
    this.props.unsetTargetAgent();
  }

  removeAgentProp() {
    this.props.removeAgent();
  }

  setChosenAgent(property, value) {
    this.props.setTargetAgent(property, value);

    const csrId = property[value].Id;
    const { fromDate, toDate } = getDates();

    this.props.fetchAgentReport(csrId, fromDate, toDate);
  }

  removeAccountProp() {
    this.props.removeAccount();
  }

  removeAccountReportProp() {
    this.props.removeAccountReport();
  }

  setChosenAccount(property, value) {
    this.props.setTargetAccount(property, value);
  }

  render() {
    const {
      agents,
      agentReport,
      agentReportError,
      accounts,
      accountReport,
      accountReportError,
      chosenAccount,
      chosenAgent,
      didPickAccount,
    } = this.props;
    const isEmpty = accnt => Object.entries(accnt).length === 0;

    const shouldDisplayAccountResults = !didPickAccount && accounts && !isEmpty(accounts);

    const shouldDisplayUserListTable =
      (accountReportError || !accountReport) && chosenAccount && !isEmpty(chosenAccount);

    const shouldDisplayAccountReport = !accountReportError && accountReport;

    const shouldDisplayAgentResults = (!agentReport || agentReportError) && agents && !isEmpty(agents);

    const shouldDisplayReport = !agentReportError && agentReport;

    return (
      <>
        {shouldDisplayAccountResults && (
          <div className={'card-container'}>
            <AccountResults
              data={accounts}
              okButtonClick={this.setChosenAccount}
              removeAccount={this.removeAccountProp}
            />
          </div>
        )}

        {shouldDisplayAccountReport ? (
          <div className={'card-container'}>
            <AccountHistory
              accountData={chosenAccount}
              data={accountReport}
              onBackButtonClick={this.removeAccountReportProp}
              onCancelButtonClick={this.removeAccountReportProp}
            />
          </div>
        ) : (
          shouldDisplayUserListTable && (
            <div className={'card-container'}>
              <UserList
                accountData={chosenAccount}
                initUser={this.props.initializeUser}
                switchTypeData={this.props.switchTypeData}
              />
            </div>
          )
        )}

        {shouldDisplayAgentResults ? (
          <div className={'card-container'}>
            <CSRAgentsResults data={agents} okButtonClick={this.setChosenAgent} removeAgent={this.removeAgentProp} />
          </div>
        ) : (
          shouldDisplayReport && (
            <div className={'card-container'}>
              <CSRAgentReports
                agentData={chosenAgent}
                data={agentReport}
                onBackButtonClick={this.removeChosenAgent}
                onCancelButtonClick={this.removeAgentProp}
              />
            </div>
          )
        )}
      </>
    );
  }
}

export function mapStateToProps({
  account: { accounts },
  agent: { agents },
  switchType: switchTypeData,
  targetAccount: { didPickAccount, chosenAccount },
  targetAccountReport: { report: accountReport, error: accountReportError },
  targetAgent: { didPickAgent, chosenAgent },
  targetAgentReport: { report: agentReport, error: agentReportError },
}) {
  return {
    accounts,
    accountReportError,
    agents,
    agentReportError,
    didPickAccount,
    didPickAgent,
    chosenAccount,
    chosenAgent,
    accountReport,
    agentReport,
    switchTypeData,
  };
}

export default connect(mapStateToProps, {
  fetchAgentReport,
  fetchSwitchType,
  clearSwitchType,
  initializeUser,
  removeAccount,
  removeAccountReport,
  removeAgent,
  setTargetAccount,
  setTargetAgent,
  unsetTargetAgent,
})(ListManager);
